"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageLotteryForm = void 0;
const block_tracker_hooks_1 = require("@hooks/block-tracker.hooks");
const lottery_hooks_1 = require("@hooks/contracts/lottery.hooks");
const user_hooks_1 = require("@hooks/user.hooks");
const button_1 = require("@shared-modules/components/button");
const profile_avatar_1 = require("@shared-modules/components/profile-avatar");
const object_1 = require("@utils/object");
const number_1 = require("@utils/object/number");
const React = __importStar(require("react"));
const react_1 = require("react");
const unknown_png_1 = __importDefault(require("@assets/unknown.png"));
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const event_timer_1 = require("../event-timer");
const token_info_1 = require("../token-info");
const ManageLotteryForm = (props) => {
    const { lottery, updateToken } = props;
    const translator = (0, translation_hooks_1.usePagesTranslation)("tokenPage.manageLotteryForm");
    const [isLoaderVisible, setLoaderVisibility] = (0, react_1.useState)(false);
    const [winner, setWinner] = (0, react_1.useState)();
    const paymentToken = (0, tokens_reducer_1.useTokenByAddress)(lottery.paymentTokenAddress);
    const { waitBlock } = (0, block_tracker_hooks_1.useBlockTracker)(() => {
        updateToken();
        setLoaderVisibility(false);
    });
    const isAnyBought = (lottery.soldTickets || 0) !== 0;
    const finalizeLottery = (0, lottery_hooks_1.useFinalizeLottery)(lottery.tokenId, lottery.contractAddress, isAnyBought);
    const finalizeLotteryHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoaderVisibility(true);
            const [winner, result] = yield finalizeLottery();
            setWinner(winner);
            const { blockNumber } = (yield result) || {};
            waitBlock(blockNumber);
        }
        catch (error) {
            setLoaderVisibility(false);
        }
    });
    const ticketsLeft = (lottery.totalTickets || 0) - (lottery.soldTickets || 0);
    const isSoldOut = ticketsLeft === 0;
    const { data: winnerProfile } = (0, user_hooks_1.useUserByAccount)(winner);
    const isLotteryExpired = lottery.endLotteryDate < new Date().getTime();
    const lotteryInfo = [
        {
            label: translator("ticketPriceLabel"),
            currencySymbol: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.symbol,
            value: (0, number_1.formatAndNormalizeToken)(paymentToken, lottery === null || lottery === void 0 ? void 0 : lottery.ticketPrice, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals),
        },
        {
            label: translator("ticketsLeftLabel"),
            value: isSoldOut ? translator("soldOutLabel") : translator("ticketsLeftValueLabel", { ticketsLeft }),
            comment: translator("soldShare", {
                share: lottery ? (0, number_1.formatBigNumber)((lottery.soldTickets / lottery.totalTickets) * 100) : "-",
            }),
        },
    ];
    return (React.createElement("div", { className: "c-token-page-manage-lottery-form" },
        React.createElement(event_timer_1.EventTimer, { startTime: 0, endTime: lottery.endLotteryDate, onUpdate: updateToken, eventName: translator("eventName") }),
        React.createElement(token_info_1.TokenInfo, { cells: lotteryInfo }),
        !isLotteryExpired && (React.createElement("div", { className: "c-token-page-manage-lottery-form__warning" }, translator("lotteryNotEndedMessage"))),
        winnerProfile && (React.createElement("div", { className: "c-token-page-manage-lottery-form__winner" },
            React.createElement("div", { className: "c-token-page-manage-lottery-form__user" },
                React.createElement(profile_avatar_1.ProfileAvatar, { height: "45px", width: "45px", src: (winnerProfile === null || winnerProfile === void 0 ? void 0 : winnerProfile.avatar) || unknown_png_1.default }),
                React.createElement("div", { className: "c-token-page-manage-lottery-form__user-info" },
                    React.createElement("div", { className: "c-token-page-manage-lottery-form__user-role" }, translator("winnerLabel")),
                    React.createElement("div", { className: "c-token-page-manage-lottery-form__user-name" },
                        React.createElement("a", { target: "_blank", href: `/profile/${winner}`, title: winner, className: "c-token-page-manage-lottery-form__user-name g-link" }, winnerProfile.firstName || winnerProfile.lastName
                            ? (0, object_1.concatStringsWithWhitespace)(winnerProfile.firstName, winnerProfile.lastName)
                            : (0, object_1.formatAddress)(winner))))))),
        React.createElement("div", { className: "c-token-page-manage-lottery-form__buttons" },
            React.createElement(button_1.Button, { loading: isLoaderVisible, disabled: isLoaderVisible || !isLotteryExpired || Boolean(winner), onClick: finalizeLotteryHandler }, isAnyBought ? translator("finalizeButton") : translator("cancelButton")))));
};
exports.ManageLotteryForm = ManageLotteryForm;
